import { Component, Input, Output, EventEmitter, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DocumentService } from 'src/app/core/services/document.service';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { MESSAGECONSTANTS } from 'src/app/core/utils/constants';

@Component({
  selector: 'app-add-edit-document-folder',
  templateUrl: './add-edit-document-folder.component.html',
  styleUrls: ['./add-edit-document-folder.component.css']
})
export class AddEditDocumentFolderComponent implements OnInit {
  @ViewChild('documentFolderForm') documentFolderForm: NgForm;

  @Input() folder: any;
  @Input() folders: any;
  @Input() parentFolderName: any;
  @Output() saveCallback = new EventEmitter<any>();
  @Output() cancelCallback = new EventEmitter<any>();

  MESSAGECONSTANTS: any = MESSAGECONSTANTS;

  editingFolder: any;
  savingFlag = false;

  constructor(
    private documentService: DocumentService,
    private alertsAndNotificationsService: AlertAndNotificationsService
  ) { }

  ngOnInit() {
    this.savingFlag = false;
    this.editingFolder = Object.assign({}, this.folder);
  }

  save() {
    if (!this.documentFolderForm.invalid) {
      if (this.folder.id) {
        if (((this.editingFolder.name !== this.folder.name) && !this._isFolderNameDuplicate()) ||
          ((this.editingFolder.name === this.folder.name) && (this.editingFolder.description !== this.folder.description))) {
          this.savingFlag = true;
          this.documentService.updateCandidateDocumentFolder(this.folder, (data) => {
            this._setFolder(data);
          }, error => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        } else if (((this.editingFolder.name !== this.folder.name) && this._isFolderNameDuplicate())) {
          this._showDuplicateMessageAlert();
        } else {
          this.alertsAndNotificationsService.showBannerMessage('Nothing to update', 'info');
        }
      } else {
        if (!this._isFolderNameDuplicate()) {
          this.savingFlag = true;
          this.documentService.addCandidateDocumentFolder(this.folder, (data) => {
            this._setFolder(data);
          }, error => {
            this.savingFlag = false;
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          });
        } else {
          this._showDuplicateMessageAlert();
        }
      }
    }
  }

  private _showDuplicateMessageAlert() {
    const title = 'Duplicate Folder Name';
    const message = `Folder with name <b>'${this.folder.name}'</b> already exists. Please use another name.`;
    this.alertsAndNotificationsService.showAlert(title, message, 'warning');
  }

  private _setFolder(folder) {
    this.folder = folder;
    this.savingFlag = false;
    if (this.saveCallback) {
      this.saveCallback.emit(this.folder);
    }
  }

  cancel() {
    if (this.cancelCallback) {
      this.cancelCallback.emit();
    }
  }

  private _isFolderNameDuplicate() {
    let isFolderNameExists = false;
    if (this.folders && this.folders.length > 0) {
      for (const parentFolder of this.folders) {
        if (parentFolder.name === this.folder.name) {
          isFolderNameExists = true;
          break;
        } else if (parentFolder.folders.length > 0) {
          for (const childFolder of parentFolder.folders) {
            if (this.folder.name === childFolder.name) {
              isFolderNameExists = true;
              break;
            }
          }
        }
      }
    }
    return isFolderNameExists;
  }

}
